import { useAuth } from '@ben/shared/providers/auth-provider';
import { useQuery } from '@tanstack/react-query';
import type { UiConfig } from '../../api/ea/ui-config';
import { getUiConfig } from '../../api/ea/ui-config';
import type { TUseQueryOptions } from './use-query-base';
import { createInvalidateHook } from './use-query-base';

const QUERY_KEY = 'employeeSideMenu';

const getKey = () => {
  return [QUERY_KEY];
};

export const useQueryEmployeeSideMenu = (
  options?: TUseQueryOptions<UiConfig>
) => {
  const { isAuthenticated } = useAuth();
  const result = useQuery<UiConfig>({
    ...options,
    enabled: isAuthenticated && options?.enabled !== false,
    queryKey: getKey(),
    queryFn: getUiConfig,
  });
  return {
    ...result,
    isLoading: isAuthenticated ? result.isLoading : false,
  };
};

export const useInvalidateEmployeeSideMenu = createInvalidateHook(getKey);
